import React, { FC } from 'react';

import { Settings } from '../../interfaces/Stylesheet';
import style from './PreHeader.module.scss';

interface PreHeaderProps {
  settings: Settings;
}

const PreHeaderComponent: FC<PreHeaderProps> = ({ settings }: PreHeaderProps) => {
  return (
    <div className={style.ticketHeader}>
      <div className={style.preheader}>
        {!!settings.logoUrl && (
          <img
            alt={settings.partnerName + ' logo'}
            className={style.ticketHeaderItem}
            src={settings.logoUrl}
          />
        )}
        <div className={style.ticketHeaderRightCol}>
          {!!settings.showGuidionLogo && (
            <img
              alt="Guidion logo"
              className={style.ticketHeaderItem}
              src="https://cdn.guidion.com/guidion-branding/logo-medium.png"
            />
          )}
          {/*
          Can be put back once the questionnare bug is fixed
          <LanguageSelector
            className={style.ticketHeaderItem}
            placement="header-desktop"
          />
          */}
        </div>
      </div>
    </div>
  );
};

export const PreHeader = React.memo(PreHeaderComponent);
